export default __webpack_public_path__ + "arrow_left_56.svg";